import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { RFFORMINFO, RF_TC_FORM_FIELD } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list RFFormInfos.
 * @returns {Promise} - A promise that resolves with the list of RFFormInfos or rejects with an error.
 * @param props
 */
export const listRFFormInfo = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${RFFORMINFO}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    RFFormInfo: response?.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create RFFormInfo.
 * @returns {Promise} - A promise that resolves with the creation of Form Info or rejects with an error.
 * @param data
 */
export const createRFFormInfo = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RFFORMINFO}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update RFFormInfo.
 * @returns {Promise} - A promise that resolves with the update of Form Info or rejects with an error.
 * @param data
 */
export const updateRFFormInfo = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RFFORMINFO}/${doubleEncode(data?.ossiTcFormId)}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete RFFormInfo.
 * @returns {Promise} - A promise that resolves with the update of Form Info or rejects with an error.
 * @param data
 */
export const deleteRFFormInfo = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RFFORMINFO}?tenant_id=${encodeURIComponent(data?.tenantId)}&ossi_tc_form_id=${encodeURIComponent(data?.ossiTcFormId)}&uc_ossi_appl_id=${encodeURIComponent(data?.ucOssiApplId)}&uc_ossi_app_ver=${encodeURIComponent(data?.ucOssiAppVer)}&uc_ossi_srtseq=${encodeURIComponent(data?.ucOssiSrtseq)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get RFFormInfo.
 * @returns {Promise} - A promise that resolves with the RFFormInfo or rejects with an error.
 * @param data
 */
export const getRFFormInfo = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RFFORMINFO}?tenant_id=${encodeURIComponent(data?.tenantId)}&uc_ossi_form_id=${encodeURIComponent(data?.ossiTcFormId)}&uc_ossi_appl_id=${encodeURIComponent(data?.ucOssiApplId)}&uc_ossi_app_ver=${encodeURIComponent(data?.ucOssiAppVer)}&uc_ossi_srtseq=${encodeURIComponent(data?.ucOssiSrtseq)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * Create RFFormInfo.
 * @returns {Promise} - A promise that resolves with the creation of Form Info or rejects with an error.
 * @param data
 */
export const getRFTCFormField = async ({
  moduleName,
  isServiceWorker,
  listController,
  version,
  formId,
  fieldId,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_TC_FORM_FIELD}/Filter?UcOssiAppVer=${version ? encodeURIComponent(version) : ''}&OssiTCFormId=${formId ? encodeURIComponent(formId) : ''}&OssiTCFldId=${fieldId ? encodeURIComponent(fieldId) : ''}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

